export function teacherSubmissionReviewUrl(
  cohortId: string,
  lessonId: string,
  lessonTitle: string,
  studentUserId: string
): string {
  const qs = new URLSearchParams({ title: lessonTitle, student: studentUserId });
  return `/teacher/cohorts/${encodeURIComponent(cohortId)}/lessons/${encodeURIComponent(lessonId)}/submissions?${qs.toString()}`;
}
